import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter as Router} from 'react-router-dom'
import {createStore, applyMiddleware, compose} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise';
import CssBaseline from '@material-ui/core/CssBaseline'
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles'
import 'typeface-roboto'
import {redirect} from './actions/router'
import rootReducer from './reducers/root'
import App from './containers/App'
import axios from "axios";
import dateFormat from 'dateformat'

dateFormat.masks.germanDateTime = 'dd.mm.yyyy HH:MM';
dateFormat.masks.germanDate = 'dd.mm.yyyy';

const onAxiosResponse = (config) => {
    return Promise.resolve(config);
};

const onAxiosError = (error) => {
    return Promise.reject(error);
};

axios.defaults.baseURL = process.env.REACT_APP_API_URL +'/';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Accept-Language'] = 'de';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.interceptors.response.use(onAxiosResponse, onAxiosError);

export const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: '#1e90ff',
        },
        secondary: {
            main: '#72b73a',
        },
    },
});

export const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    appFrame: {
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
    },
    flex: {
        flex: 1,
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: 0,
        marginTop: theme.spacing.unit * 7,
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing.unit * 8,
        },
    },
});

const el = document.getElementById('root');
window.appStandalone = (1 === parseInt(el.getAttribute('data-standalone'), 10));
window.presumeUserIsLoggedIn = (process.env.NODE_ENV !== 'production');

const composeWithDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    {},
    composeWithDevTools(applyMiddleware(thunk, promise)),
);

window.webappNavigate = (url) => {
    if (window.location.pathname === url) {
        return;
    }
    if (!window.appStandalone) {
        const serversideContent = document.getElementById('serverside-content');
        if (serversideContent) serversideContent.innerHTML = '';
    }
    store.dispatch(redirect(url));
};

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        <Provider store={store}>
            <Router>
                <App />
            </Router>
        </Provider>
    </MuiThemeProvider>
, el);



// WEBPACK FOOTER //
// ./src/index.js